import {
  FETCH_COUNTRIES_REQUEST,
  FETCH_COUNTRIES_SUCCESS,
  FETCH_COUNTRIES_FAILURE,
  SAVE_COUNTRY_REQUEST,
  SAVE_COUNTRY_SUCCESS,
  SAVE_COUNTRY_FAILURE,
  DELETE_COUNTRY_REQUEST,
  DELETE_COUNTRY_SUCCESS,
  DELETE_COUNTRY_FAILURE,
} from './types';

const INITIAL_STATE = {
  countryList: [],
  loading: false,
  error: null,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_COUNTRIES_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case FETCH_COUNTRIES_SUCCESS:
      return {
        ...state,
        loading: false,
        countryList: action.payload,
      };

    case FETCH_COUNTRIES_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
        countryList: [],
      };
    case SAVE_COUNTRY_REQUEST:
      return {
        ...state,
        error: null,
      };

    case SAVE_COUNTRY_SUCCESS:
      return {
        ...state,
      };

    case SAVE_COUNTRY_FAILURE:
      return {
        ...state,
        error: action.payload.error,
      };

    case DELETE_COUNTRY_REQUEST:
      return {
        ...state,
        error: null,
      };

    case DELETE_COUNTRY_SUCCESS:
      return {
        ...state,
      };

    case DELETE_COUNTRY_FAILURE:
      return {
        ...state,
        error: action.payload.error,
      };
    default:
      // ALWAYS have a default case in a reducer
      return state;
  }
};
